<router-outlet></router-outlet>
<ngx-ui-loader
    bgsColor="#ffcc48"
    text="loading..."
    pbColor="#b12bf7"
    fgsType="square-jelly-box"
>
</ngx-ui-loader>